import * as React from 'react';
import { MoneyInput } from './money-input';

type MoneyFieldProps = {
  id: string;
  label: string;
  value: number | undefined;
  onChange: (value: number | undefined) => void;
  onBlur?: () => void;
  error?: string;
  disabled?: boolean;
  suffix?: string;
  description?: React.ReactNode;
  placeholder?: string;
  decimalScale?: number;
};

export function MoneyField({
  id,
  label,
  value,
  onChange,
  onBlur,
  error,
  disabled,
  suffix,
  description,
  placeholder,
  decimalScale = 2
}: MoneyFieldProps) {
  return (
    <div className="flex flex-col gap-1">
      <label htmlFor={id} className="text-sm font-medium">
        {label}
        {suffix ? <span className="text-muted-foreground ml-1">({suffix})</span> : null}
      </label>
      {description ? <span className="text-muted-foreground text-xs">{description}</span> : null}
      <MoneyInput
        id={id}
        aria-label={label}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        disabled={disabled}
        placeholder={placeholder}
        decimalScale={decimalScale}
        aria-invalid={error ? true : undefined}
      />
      {error ? <span className="text-destructive text-sm">{error}</span> : null}
    </div>
  );
}
